import {Box, Button} from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

export interface SessionCompleteActionsProps {
  onBackToDashboard: () => void;
  onStartNewSession: () => void;
  onRetry?: () => void;
  retryLoading?: boolean;
}

export default function SessionCompleteActions({
  onBackToDashboard,
  onStartNewSession,
  onRetry,
  retryLoading,
}: SessionCompleteActionsProps) {
  return (
    <Box sx={{display: 'flex', gap: 2, justifyContent: 'center', pt: 2, flexWrap: 'wrap'}}>
      <Button onClick={onBackToDashboard} variant="outlined" size="large" data-testid="back-to-dashboard-button">
        Back to Dashboard
      </Button>
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="outlined"
          size="large"
          startIcon={<ReplayIcon />}
          disabled={retryLoading}
          data-testid="retry-session-button"
        >
          Retry
        </Button>
      )}
      <Button onClick={onStartNewSession} variant="contained" size="large" data-testid="start-new-session-button">
        Start New Session
      </Button>
    </Box>
  );
}
